type BriefingIconProps = {
  type: "trend" | "clock" | "shield" | "alert";
};

export function BriefingIcon({ type }: BriefingIconProps) {
  const iconClassName = "h-4 w-4 stroke-current fill-none stroke-2";

  if (type === "clock") {
    return (
      <svg viewBox="0 0 24 24" className={iconClassName}>
        <circle cx="12" cy="12" r="9" />
        <path d="M12 7v6l4 2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    );
  }

  if (type === "shield") {
    return (
      <svg viewBox="0 0 24 24" className={iconClassName}>
        <path d="M12 3l8 4v5c0 4.5-3 8.4-8 9-5-0.6-8-4.5-8-9V7l8-4z" />
        <path
          d="M8.5 12.5l2.1 2.2 4.9-5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  if (type === "alert") {
    return (
      <svg viewBox="0 0 24 24" className={iconClassName}>
        <path d="M12 4l9 16H3L12 4z" />
        <path d="M12 10v4" strokeLinecap="round" />
        <circle cx="12" cy="17" r="1" />
      </svg>
    );
  }

  return (
    <svg viewBox="0 0 24 24" className={iconClassName}>
      <path
        d="M4 13h4l3-8 4 16 3-8h2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SecurityTrendIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      width="12"
      height="12"
      stroke="currentColor"
      strokeWidth="2"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3 3v18h18" />
      <path d="M7 14l3-3 4 4 5-6" />
    </svg>
  );
}
